import './categories.css';
import React, { useEffect } from 'react';
import { useNavigate } from "react-router-dom";
import { loadCategories,updateCategory } from '../redux/productSlice';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux'
import {fetchData} from '../api/index.js';

const fetchCategories = () => async (dispatch) => {
  try {
      let endpoint = "Products/categories";
      const data = await fetchData(endpoint);
      if (data === 404 || data === 400){
        dispatch(loadCategories(["server error"]));
      } else {
         dispatch(loadCategories(data));
      }
  } catch (error) {
      console.log(error);
  }
  };

  const handleInputChange = (dispatch,value,navigate) => {
    try {
      dispatch(updateCategory(value));
      navigate(0);
    } catch (err) {
      console.log(err);
    }
  };

const Categories = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    dispatch(fetchCategories());
  }, [dispatch]);

  const categories = useSelector((state) => state.products.categories);

  if (!Array.isArray(categories)) {
    <div>
      <p>Product API error! </p>
    </div> 
  } else {
    return (
      
      <div className="categories">
        <h4 className="categoryTitle">Categories</h4>
        {categories?.map((category,i) => (
          <div key={i}>
            <button onClick={(e) =>{handleInputChange(dispatch,category.category,navigate)}} className="categoryButton">{category.category}</button>
          </div>
        ))}
      </div>
    );
  }
  };

  export default Categories;